// src/AppWithStyles.js
import App from "./App";
import "./custom.css"; // Archivo CSS para estilos personalizados

export default function AppWithStyles() {
  return (
    <div className="custom-styles">
      <App />
    </div>
  );
}
